<script lang="ts">
	//UI
	import { Card } from "@hitit/new_ui/src";
	import { link } from "svelte-routing";
	//Utils
	//Types
	//Props
	export let date = "";
	export let title = "";
	export let status = "";
	export let linkHref = "";
	export let read = false;
	export let viewInfo = {
		viewCount: 0,
		display: false,
	};

	//Constants
	//Variables
	//Functions
	//Do
</script>

<li>
	<a use:link href={linkHref}>
		<Card noPadding>
			<div class="container" class:read={read}>
				<div class="top">
					<div class="status-date">
						{#if status !== ""}
							<span
								class:obsolete={status === "OBSOLETE"}
								class:published={status === "PUBLISHED"}
								class="status"
							/>
						{/if}
						<span class="date"> {date} </span>
					</div>
					{#if viewInfo.display}
						<div class="view">
							읽음 {viewInfo.viewCount}
						</div>
					{/if}
				</div>
				<div class="bottom title">{title}</div>
			</div>
		</Card>
	</a>
</li>

<style lang="scss">
	@import "../variables.scss";
	li,
	a {
		width: 100%;
		text-decoration: none;
	}

	.container {
		display: flex;
		flex-direction: column;
		width: 100%;
		padding: 10px;
		gap: 19px;
		box-sizing: border-box;

		.status-date {
			display: flex;
			align-items: center;
			gap: 10px;

			.status {
				width: 15px;
				height: 15px;
				background-color: #bcbfc3;
				border-radius: 15px;

				&.obsolete {
					background-color: #ffce00;
				}
				&.published {
					background-color: #44e4ae;
				}
			}
			.date {
				font-size: 1rem;
				color: #46474b;
				margin-top: -2px;
			}
		}

		.view {
			color: #6d6f76;
		}

		.top {
			display: flex;
			align-items: center;
			justify-content: space-between;
		}

		.bottom {
			width: 100%;
			max-width: 100%;
			/* overflow: hidden;
			text-overflow: ellipsis;
			white-space: pre; */
			color: #46474b;
			font-weight: 500;
			word-break: break-all;
			line-height: 1.375rem;
		}

		&.read {
			.bottom {
				color: #bcbfc3;
			}

			.status-date .date {
				color: #bcbfc3;
			}
		}
	}
	@include DesktopSize {
		.container {
			padding: 20px;
			gap: 13px;
			.status-date {
				.date {
					font-size: 1.25rem;
				}
			}
			.bottom {
				line-height: 1.875rem;
				font-size: 1.25rem;
			}

			.view {
				font-size: 1.25rem;
			}
		}
	}
</style>
